<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
        <el-button
          v-hp="'add'"
          style="margin-right: 10px"
          type="primary"
          @click="create"
        >
          新建
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button v-hp="'export'" style="margin-right: 10px">导出</el-button>
      </div>
    </customize-page>
    <form-modal
      :show.sync="showModal"
      :currentBrand="currentBrand"
      @on-submit="formSubmit"
    ></form-modal>
    <el-dialog
      title="绑定用户角色"
      :visible.sync="showBindRoleFlag"
      width="360px"
    >
      <el-form>
        <el-form-item label="角色">
          <el-select
            style="width: 260px"
            v-model="roleBind.selected"
            multiple
            placeholder="请选择角色"
          >
            <el-option
              v-for="item in roleBind.options"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-on:click="saveBindRole"
            style="float: right"
            type="primary"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="维护仓单用户资格"
      :visible.sync="showWarehouseReceiptUserFlag"
      width="360px"
    >
      <el-form>
        <el-form-item label="仓单用户">
          <el-switch
            v-model="warehouseReceiptUser"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="saveWarehouseReceiptUser"
            style="float: right"
            type="primary"
          >
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="绑定货主"
      :visible.sync="showCustomerIdBindFlag"
      width="360px"
    >
      <el-form>
        <el-form-item label="货主id">
          <el-input v-model="customerId"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-on:click="saveCustomerIdBind"
            style="float: right"
            type="primary"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="绑定商户"
      :visible.sync="showMerchantBindFlag"
      width="360px"
    >
      <el-form>
        <el-form-item label="商户">
          <el-select
            filterable
            style="width: 260px"
            v-model="merchantIds"
            multiple
            placeholder="请选择商户"
          >
            <el-option
              v-for="item in getMerchantList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-on:click="saveMerchantBind"
            style="float: right"
            type="primary"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="修改密码"
      :visible.sync="showEditUserPasswordDirect"
      width="360px"
    >
      <el-form :label-position="'left'">
        <el-form-item label="新密码">
          <el-input
            v-model="passwordForm.newPwd"
            type="password"
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input
            type="password"
            v-model="passwordForm.confirmPwd"
            placeholder="请输入确认密码"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-on:click="saveEditUserPasswordDirect"
            style="float: right"
            type="primary"
            >保存
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import formModal from "./components/form-modal";
import { mapActions, mapGetters } from "vuex";
import md5 from "md5";
import { CONST_PASSWORD_SLOT } from "@/config/constant";

export default {
  components: {
    CustomizePage,
    formModal
  },
  mixins: [Page],
  activated() {
    this.listAllRole({ request: {} }).then(res => {
      this.roleBind.options = res.items;
    });
  },
  created() {},
  mounted() {
    this.fetch();
  },
  data() {
    return {
      currentUser: null,
      merchantIds: [],
      showMerchantBindFlag: false,
      showEditUserPasswordDirect: false,
      showCustomerIdBindFlag: false,
      showWarehouseReceiptUserFlag: false,
      warehouseReceiptUser: false,
      customerId: "",
      passwordForm: {
        newPwd: "",
        confirmPwd: "",
        userId: ""
      },
      roleBind: {
        selected: [],
        options: [],
        serverBindRoleMap: {},
        currentUserId: 0
      },
      showBindRoleFlag: false,
      showModal: false,
      currentBrand: {},
      loading: false,
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center"
        },
        { title: "用户名", key: "nick", "min-width": 160, align: "center" },
        { title: "电子邮件", key: "email", "min-width": 160, align: "center" },
        {
          title: "手机号",
          key: "cellphone",
          width: 160,
          align: "center"
        },
        {
          title: "货主id",
          key: "customerId",
          width: 150,
          align: "center",
          render: (h, param) => {
            let result = [];
            let customerId = param.row.customerId;
            if (customerId != null && customerId.trim().length > 0) {
              customerId
                .trim()
                .split(",")
                .forEach(name => {
                  result.push(<el-tag size="mini">{name}</el-tag>);
                });
            }
            return result;
          }
        },
        {
          title: "类型",
          key: "typeStr",
          width: 150,
          align: "center",
          render: (h, param) => (
            <div>
              <div>{param.row.typeStr}</div>
              {param.row.warehouseReceiptUser ? (
                <el-tag size="mini">仓单用户</el-tag>
              ) : null}
            </div>
          )
        },
        {
          title: "状态",
          key: "status",
          width: 150,
          align: "center",
          render: (h, param) => {
            let statusStr = param.row.status === 1 ? "可用" : "停用";
            return <el-tag>{statusStr}</el-tag>;
          }
        },
        {
          title: "操作",
          "min-width": 150,
          align: "center",
          render: (h, param) => {
            let operation = [];
            if (this.$hasPermission(this.$route, "bindRole")) {
              operation.push(
                <el-button
                  v-on:click={this.showBindRole.bind(this, param.row)}
                  type="text"
                >
                  绑定角色
                </el-button>
              );
            }
            operation.push(
              <el-button
                v-on:click={this.showWarehouseReceiptUserDialog.bind(
                  this,
                  param.row
                )}
                type="text"
              >
                仓单用户资格
              </el-button>
            );
            if (this.$hasPermission(this.$route, "bindCustomerId")) {
              operation.push(
                <el-button
                  v-on:click={this.showCustomerIdBindDialog.bind(
                    this,
                    param.row
                  )}
                  type="text"
                >
                  绑定货主
                </el-button>
              );
            }
            if (this.$hasPermission(this.$route, "bindMerchant")) {
              operation.push(
                <el-button
                  v-on:click={this.showMerchantBindDialog.bind(this, param.row)}
                  type="text"
                >
                  绑定商户
                </el-button>
              );
            }

            if (this.$hasPermission(this.$route, "changePwd")) {
              operation.push(
                <el-button
                  v-on:click={this.showEditUserPasswordDirectEvent.bind(
                    this,
                    param.row
                  )}
                  type="text"
                >
                  修改密码
                </el-button>
              );
            }

            if (this.$hasPermission(this.$route, "enableOrDisable")) {
              let enableOrDisableOperationTest = "启用用户";
              if (param.row.status == 1) {
                enableOrDisableOperationTest = "禁用用户";
              }
              operation.push(
                <el-button
                  v-on:click={this.changeUserStatusEvent.bind(this, param.row)}
                  type="text"
                >
                  {enableOrDisableOperationTest}
                </el-button>
              );
            }

            return operation;
          }
        }
      ],
      filterObj: {
        type: "-1",
        status: "-1",
        searchConditionType: "",
        searchValue: ""
      },
      currentRow: [],
      sortObj: {}
    };
  },
  computed: {
    ...mapGetters(["getMerchantList"])
  },
  methods: {
    ...mapActions("userRoleStore", {
      userBindRole: "userBindRole",
      userRoleList: "userRoleList"
    }),
    ...mapActions("roleStore", {
      listAllRole: "listAllRole"
    }),
    ...mapActions([
      "bindCustomerId",
      "bindMerchant",
      "setWarehouseReceiptUser",
      "changeUserStatus",
      "editUserPasswordDirect"
    ]),
    showWarehouseReceiptUserDialog(data) {
      this.currentUser = data;
      this.warehouseReceiptUser = Boolean(data.warehouseReceiptUser);
      this.showWarehouseReceiptUserFlag = true;
    },
    saveWarehouseReceiptUser() {
      return this.setWarehouseReceiptUser({
        targetUserId: this.currentUser.userId,
        warehouseReceiptUser: this.warehouseReceiptUser
      })
        .then(res => {
          if (!res.value) {
            const stat = res.stat && res.stat.statList && res.stat.statList[0];
            this.$message.error(stat ? stat.msg : "保存失败");
            return false;
          }
          this.showWarehouseReceiptUserFlag = false;
          this.$message.success("保存成功");
          return this.fetch();
        })
        .catch(error => {
          this.$message.error(
            (error && (error.msg || error.message)) || "保存失败"
          );
          return false;
        });
    },
    saveMerchantBind() {
      let bindMerchantList = [];
      this.merchantIds.forEach(item => {
        bindMerchantList.push({
          merchantId: item
        });
      });
      this.bindMerchant({
        request: JSON.stringify({
          userId: this.currentUser.userId,
          data: bindMerchantList
        })
      }).then(res => {
        if (res.value) {
          this.showMerchantBindFlag = !this.showMerchantBindFlag;
          this.fetch();
          this.$message.success("保存成功");
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    showCustomerIdBindDialog(data) {
      this.showCustomerIdBindFlag = !this.showCustomerIdBindFlag;
      this.currentUser = data;
      this.customerId = data.customerId;
    },
    showMerchantBindDialog(data) {
      this.showMerchantBindFlag = !this.showMerchantBindFlag;
      this.currentUser = data;
      this.merchantIds = [];
      if (data.merchantIds != null && data.merchantIds.length > 0) {
        this.merchantIds = data.merchantIds.split(",");
      }
    },
    saveCustomerIdBind() {
      this.bindCustomerId({
        userId: this.currentUser.userId,
        customerId: this.customerId
      }).then(res => {
        if (res.value) {
          this.showCustomerIdBindFlag = !this.showCustomerIdBindFlag;
          this.fetch();
          this.$message.success("保存成功");
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    changeUserStatusEvent(data) {
      let status = 1;
      if (data.status == 1) {
        status = 0;
      }
      this.changeUserStatus({
        req: {
          userId: data.userId,
          status
        }
      }).then(res => {
        if (res.value) {
          data.status = status;
          this.$message.success("成功");
        }
      });
    },
    fetch(data) {
      this.loading = true;
      const filterParams = this.getFilterParams();
      if (filterParams.searchConditionType != null) {
        filterParams[filterParams.searchConditionType] =
          filterParams.searchValue;
        delete filterParams.searchConditionType;
        delete filterParams.searchValue;
      }

      const sortObj = data ? data : this.sortObj;
      return this.$store
        .dispatch("omsUserList", {
          ...sortObj,
          request: {
            condition: filterParams,
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        })
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.page || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        });
    },
    showBindRole(row) {
      this.userRoleList({
        request: JSON.stringify({ userId: row.userId })
      }).then(res => {
        this.roleBind.currentUserId = row.userId;
        this.roleBind.selected = [];
        this.roleBind.serverBindRoleMap = {};
        res.roleIds.forEach((value, index) => {
          this.roleBind.selected.push(value.roleId);
          this.roleBind.serverBindRoleMap[value.roleId] = value;
        });
        this.showBindRoleFlag = !this.showBindRoleFlag;
      });
    },
    saveBindRole() {
      let changeRole = [];
      for (let i = 0; i < this.roleBind.options.length; i++) {
        let item = this.roleBind.options[i];
        let roleId = item.roleId;
        let operation = { roleId };
        if (this.roleBind.serverBindRoleMap[roleId] == null) {
          if (this.roleBind.selected.indexOf(roleId) !== -1) {
            operation.operation = 1;
          }
        } else if (this.roleBind.selected.indexOf(roleId) === -1) {
          operation.operation = 0;
        }
        if (Object.prototype.hasOwnProperty.call(operation, "operation")) {
          changeRole.push(operation);
        }
      }
      this.userBindRole({
        request: JSON.stringify({
          userId: this.roleBind.currentUserId,
          roleOperations: changeRole
        })
      }).then(res => {
        if (res.value) {
          this.$message.success("绑定成功");
          this.showBindRoleFlag = !this.showBindRoleFlag;
        } else {
          this.$message.error("绑定失败");
        }
      });
    },
    selectionChange(row) {
      this.currentRow = row;
    },
    create() {
      this.showModal = true;
    },
    formSubmit() {
      this.showModal = false;
      this.fetch();
    },
    customRest() {
      this.filterObj.status = "-1";
      this.filterObj.type = "-1";
    },
    showEditUserPasswordDirectEvent(data) {
      this.passwordForm.newPwd = "";
      this.passwordForm.confirmPwd = "";
      this.passwordForm.userId = data.userId;
      this.showEditUserPasswordDirect = !this.showEditUserPasswordDirect;
    },
    saveEditUserPasswordDirect() {
      if (!this.passwordForm.newPwd) {
        this.$message.error("请输入用户密码");
        return;
      }
      if (this.passwordForm.newPwd != this.passwordForm.confirmPwd) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      this.editUserPasswordDirect({
        req: {
          userId: this.passwordForm.userId,
          newPassword: md5(
            this.passwordForm.newPwd + CONST_PASSWORD_SLOT
          ).toLowerCase()
        }
      }).then(res => {
        if (res.value) {
          this.$message.success("操作成功");
          this.showEditUserPasswordDirect = !this.showEditUserPasswordDirect;
        }
      });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "",
              model: "searchValue",
              type: type.CONTRAST_INPUT,
              className: "flex-form-item",
              props: {
                operator: "searchConditionType",
                data: [
                  {
                    value: "nick",
                    label: "用户名"
                  },
                  {
                    value: "cellphone",
                    label: "手机号"
                  }
                ]
              }
            },
            {
              label: "类型",
              model: "type",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "-1",
                    label: "所有"
                  },
                  {
                    value: "0",
                    label: "超级用户"
                  },
                  {
                    value: "1",
                    label: "员工"
                  },
                  {
                    value: "2",
                    label: "合作伙伴"
                  }
                ]
              }
            },
            {
              label: "状态",
              model: "status",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "-1",
                    label: "所有"
                  },
                  {
                    value: "1",
                    label: "可用"
                  },
                  {
                    value: "0",
                    label: "停用"
                  }
                ]
              }
            }
          ]
        }
      ];
    }
  }
};
</script>
